import * as React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={70} height={70} viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.568 34.056a6.693 6.693 0 100-13.386 6.693 6.693 0 000 13.386zM2.144 52.053A12.425 12.425 0 0121.26 41.592M55.432 34.056a6.693 6.693 0 100-13.386 6.693 6.693 0 000 13.386zM67.856 52.053A12.424 12.424 0 0048.74 41.592M34.765 33.29a8.145 8.145 0 100-16.29 8.145 8.145 0 000 16.29zM19.475 54.998a15.29 15.29 0 0130.56 0"
        stroke="#5E5E5E"
        strokeWidth={3}
        strokeLinejoin="round"
      />
    </svg>
  );
};
